<template>
  <v-card
    :flat="flat"
    :tile="tile"
    :outlined="outlined"
    :loading="loading"
    :loader-height="loaderHeight"
    :dark="dark"
    :hover="hover"
    :disabled="disabled"
    :class="[
      'asc-panel',
      noSpacing ? 'asc-panel--noSpacing' : '',
      flat ? 'asc-panel--flat' : '',
      outlined ? 'asc-panel--outlined' : '',
      dark ? 'asc-panel--dark' : '',
      hover ? 'asc-panel--hover' : '',
    ]"
  >
    <asc-full-screen-icon
      v-if="hasFullscreenIcon"
      @onFullScreenToggle="handleFullScreenToggle"
    />
    <v-card-title v-if="hasTitleSlot" class="asc-panel__title">
      <v-clamp autoresize :max-lines="2" class="clamp">
        <slot name="title"></slot>
      </v-clamp>
    </v-card-title>
    <v-card-subtitle v-if="hasSubTitleSlot" class="asc-panel__subtitle">
      <slot name="subtitle"></slot>
    </v-card-subtitle>
    <v-divider v-if="hasTitleSlot"></v-divider>
    <v-card-text
      :class="['asc-panel__text', !hasTitleSlot ? 'asc-panel__text-cover' : '']"
      :style="{
        minHeight: `${contentMinHeight}px`,
        maxHeight: contentMaxHeight
          ? `${contentMaxHeight}px`
          : contentMaxHeight,
        padding: `${contentPaddingY}px ${contentPaddingX}px`,
        paddingBottom: contentPaddingBottom
          ? `${contentPaddingBottom}px`
          : contentPaddingBottom,
      }"
    >
      <slot></slot>
    </v-card-text>
  </v-card>
</template>

<script>
import AscFullScreenIcon from '../atoms/AscFullScreenIcon'
import VClamp from 'vue-clamp'

export default {
  name: 'AscPanel',

  components: {
    AscFullScreenIcon,
    VClamp,
  },

  props: {
    dark: {
      type: Boolean,
      default: false,
    },
    flat: {
      type: Boolean,
      default: false,
    },
    tile: {
      type: Boolean,
      default: true,
    },
    noSpacing: {
      type: Boolean,
      default: false,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    loaderHeight: {
      type: Number,
      default: 2,
    },
    hover: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    contentMinHeight: {
      type: Number,
      default: 200,
    },
    contentMaxHeight: {
      type: Number,
      default: undefined,
    },
    contentPaddingX: {
      type: Number,
      default: 16,
    },
    contentPaddingBottom: {
      type: Number,
      default: undefined,
    },
    contentPaddingY: {
      type: Number,
      default: 16,
    },

    hasFullscreenIcon: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    hasTitleSlot() {
      return !!this.$slots.title
    },

    hasSubTitleSlot() {
      return !!this.$slots.subtitle
    },
  },

  methods: {
    handleFullScreenToggle(event) {
      this.$emit('onFullScreenToggle', event)
    },
  },
}
</script>

<style lang="scss" scoped>
.asc-panel {
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.3) !important;

  &__title {
    font-size: $font-size-md;
    color: $primary-black;
    line-height: 18px;
    letter-spacing: 1px;
    text-transform: uppercase;
    font-weight: 500;
    padding: 12px 36px 12px 16px;
    word-break: break-word;
  }

  &__subtitle {
    color: $primary-black !important;
    line-height: 18px;
    padding-bottom: 12px;
    padding-left: 16px;
    font-size: 14px;
  }

  &__text {
    font-size: 14px;
    color: $primary-black !important;
    line-height: 18px;
    letter-spacing: 0;
    overflow-y: auto;
  }

  &--dark {
    background-color: $gray-200 !important;
  }

  &--noSpacing {
    padding: 0;

    .asc-panel__title {
      padding: 0;
    }

    .asc-panel__text {
      padding: 0;
      flex-grow: 1;
      overflow: auto;
    }
  }

  &--flat {
    box-shadow: none !important;

    &.asc-panel--hover {
      cursor: pointer;

      &:hover,
      &:focus {
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.3) !important;
        transition: box-shadow 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
      }
    }
  }
}
</style>
